const COMMENT_FIELDS = `
      docs {
        id
        createdAt
        isLiked
        likes
        message
        type
        userId
        user {
          id
          avatar
          rank
          username
        }
        mentionedUsers {
          id
          username
        }
        comments {
          id
          createdAt
          isLiked
          likes
          message
          type
          userId
          user {
            id
            avatar
            rank
            username
          }
          receiver {
            id
            username
          }
          mentionedUsers {
            id
            username
          }
        }
      }
      hasNextPage
      totalDocs
`;

// Parent comments, newest first, with their replies.
export const COMMENTS_PAGINATION = `
  query commentsPagination($input: CommentPaginationInput) {
    commentsPagination(input: $input) {
      ${COMMENT_FIELDS}
    }
  }
`;

// Same list for a visitor who is not logged in (read only).
export const GUEST_COMMENTS_PAGINATION = `
  query guestCommentsPagination($input: CommentPaginationInput!) {
    guestCommentsPagination(input: $input) {
      ${COMMENT_FIELDS}
    }
  }
`;
